import {Observable, Subject, Unsubscribable} from "rxjs";
import {takeUntil} from "rxjs/operators";

export interface IObservable<T> {
	subscribe(next?: (value: T) => void, error?: (error: any) => void, complete?: () => void): Unsubscribable;
}

export interface ISubject<T> extends IObservable<T> {
	next(value: T): void;
}

export class UntilObservable<T> implements IObservable<T> {
	private readonly obs: Observable<T>;

	constructor(sub: Subject<T>, $until: Subject<void>) {
		this.obs = sub.pipe(takeUntil($until));
	}

	subscribe(next?: (value: T) => void, error?: (error: any) => void, complete?: () => void): Unsubscribable {
		return this.obs.subscribe({next, error, complete});
	}
}

export class UntilSubject<T> extends UntilObservable<T> implements ISubject<T> {
	constructor(
		private readonly sub: Subject<T>,
		$until: Subject<void>,
	) {
		super(sub, $until);
	}

	next(value: T) {
		setTimeout(() => {
			this.sub.next(value);
		});
	}
}
